// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginResponseDTOAPIModel
 */
export interface LoginResponseDTOAPIModel {
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDTOAPIModel
     */
    token: string;
}

export function LoginResponseDTOAPIModelFromJSON(json: any): LoginResponseDTOAPIModel {
    return LoginResponseDTOAPIModelFromJSONTyped(json, false);
}

export function LoginResponseDTOAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseDTOAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function LoginResponseDTOAPIModelToJSON(value?: LoginResponseDTOAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}


